import postPageStateManager from '../postpage_state_manager';
import loadable from '@loadable/component';

const PostPage = loadable(() => import('../post_page'));

export default function(store) {
  return {
    path: '/best-workplaces-for-innovators/2019',
    component: PostPage,
    exact: true,
    strict: true,
    loadData: postPageStateManager(store)
  };
}
